import { Component, Input, OnInit } from '@angular/core';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-process-status-row',
    templateUrl: './process-status-row.component.html',
    styleUrls: ['./process-status-row.component.scss']
})
export class ProcessStatusRowComponent implements OnInit {
    @Input()
    process: ITaskModel;

    constructor() {}

    ngOnInit(): void {}
}
